/** Width/height, or null when no usable media dimensions are available. */
export function mediaAspectRatio(dimensions?: readonly number[] | null): number | null {
  const [width, height] = dimensions || [];
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
  const ratio = width / height;
  return Number.isFinite(ratio) && ratio > 0 ? ratio : null;
}
